import { DataLayerAnalytics } from '@com-delta-idp/mnx-skymiles-landing-page-ui';
import { AmexCardType } from '@com-delta-idp/mnx-skymiles-shared';
import { DATA_ANALYTICS, EVENT_DETAIL } from '../models';

export const getValidValue = (value: string): string => {
  return value ? value : '';
};

export const getCountry = (value: string): string => {
  return value ? value.substring(3, 5) : 'us';
};

export const getLanguage = (value: string): string => {
  return value ? value.substring(0, 2) : 'en';
};
export const getCardLabelByValue = (value: string): string => {
  const found = AmexCardType.find((option) => option.id === value);
  return found ? found.value : '';
};

export const isMobile = (): boolean =>
  /android|iphone|ipad|kindle/i.test(navigator.userAgent);

export const getModalClickAttributes = (
  analyticsData: DataLayerAnalytics,
  data: string
): DataLayerAnalytics => {
  const parsedData = JSON.parse(data);
  return {
    user: analyticsData.user,
    event: DATA_ANALYTICS.CLICK,
    event_detail: EVENT_DETAIL.MODAL_LINK_CLICK,
    click: {
      name: parsedData.action.label,
      type: 'link',
      page_section: `modal:${parsedData.section}`,
      action: parsedData.action.url
    },
    site_assets: [
      {
        id: `mod_${parsedData.index}`,
        type: 'modal',
        position: `${parsedData.index} of ${parsedData.max}`,
        source: 'page content',
        name: parsedData.section,
        sub_type: 'award'
      }
    ]
  };
};
